export { default } from "./GPSearch.gql";
